
import { Component, Vue, State } from 'nuxt-property-decorator';
import { Gender, Language } from './models';
import ReadAloudStore from './read-aloud.store';
import ClientSettingsStore from '@/store/clientSettings.store';
import { Site } from '@/types/initialData';

@Component
export default class PollyVoiceSelect extends Vue {
  currentVoiceParams: { gender: Gender; language: Language } = {
    gender: Gender.Female,
    language: Language.Danish
  };

  // @ts-ignore
  @State((state) => state.typo3?.initial?.site)
  site: Site;

  get languages() {
    return ReadAloudStore.languages;
  }

  get genders() {
    return ReadAloudStore.genders;
  }

  get currentGender(): Gender {
    return ReadAloudStore.voice.gender;
  }

  get currentLanguage(): Language {
    return ReadAloudStore.voice.language;
  }

  genderChanged(gender: number): void {
    // We set the value of the language to the store value, to prevent use of the old value
    this.currentVoiceParams.gender = gender;
    this.currentVoiceParams.language = ReadAloudStore.voice.language;
    // Swedish male does not exist in Polly
    if (
      this.currentVoiceParams.language === 6 &&
      this.currentVoiceParams.gender === 0
    ) {
      this.currentVoiceParams.gender = 1;
    }
    this.updateVoiceAndLanguage();
  }

  languageChanged(language: number): void {
    this.currentVoiceParams.language = language;

    // We set the value of the gender to the store value, to prevent use of the old value
    this.currentVoiceParams.gender = ReadAloudStore.voice.gender;
    this.updateVoiceAndLanguage();
  }

  updateVoiceAndLanguage(): void {
    ReadAloudStore.voice = ReadAloudStore.voiceSelections.find(
      (voice) =>
        voice.language === this.currentVoiceParams.language &&
        voice.gender === this.currentVoiceParams.gender
    );
    ReadAloudStore.settingsChanged = true;
    ClientSettingsStore.updateClientSettings(this.site);
  }

  private getCurrentGender(gender: Gender): string {
    switch (gender) {
      case Gender.Male:
        return this.$tc('labels.polly.gender.male');
      case Gender.Female:
        return this.$tc('labels.polly.gender.female');
      default:
        return 'Gender not in list';
    }
  }

  private getCurrentLanguage(language: Language): string {
    switch (language) {
      case Language.Danish:
        return this.$tc('labels.polly.languages.da');
      case Language.French:
        return this.$tc('labels.polly.languages.fr');
      case Language.German:
        return this.$tc('labels.polly.languages.de');
      case Language.Spanish:
        return this.$tc('labels.polly.languages.es');
      case Language.English:
        return this.$tc('labels.polly.languages.en');
      case Language.Icelandic:
        return this.$tc('labels.polly.languages.is');
      case Language.Swedish:
        return this.$tc('labels.polly.languages.se');
      default:
        return 'Language not in list';
    }
  }
}
